<template>
  <AtomHorizontalScroll>
    <div class="nav">
      <NuxtLink v-for="item in items" :key="item.text" :to="{ name: item.name, params: { team: team.slug }, query: item.query }" :class="{ 'active': item.active }">
        {{ item.text }}
      </NuxtLink>
    </div>
  </AtomHorizontalScroll>
</template>

<script setup>
const { t } = useI18n()
const route = useRoute()
const team = useTeamStore()

const items = computed(() => [
  {
    text: t('shared.nav.start'),
    name: 'team',
    active: route.name === 'team',
  },
  {
    text: t('shared.nav.fixtures'),
    name: 'team-fixtures',
    active: route.name === 'team-fixtures',
    query: {
      ...route.query
    }
  },
  {
    text: t('shared.nav.results'),
    name: 'team-results',
    active: route.name === 'team-results',
    query: {
      ...route.query
    }
  },
  {
    text: t('shared.nav.table'),
    name: 'team-table',
    active: route.name === 'team-table',
    query: {
      ...route.query
    }
  },
  // {
  //   text: t('shared.nav.statistics'),
  //   name: 'team-statistics',
  //   active: route.name === 'team-statistics',
  // }
])
</script>